import './css/styles.scss';

/**
 * Filtrerar referenskorten på kategori.
 *
 * Samma upplägg som produktfiltret: korten ligger redan i markupen med sina
 * kategorier i data-category, och filtret visar eller döljer dem. Ingen
 * omladdning och ingen serverrunda.
 */
function referensFilterInit(): void {
	document.querySelectorAll<HTMLElement>('.referens-arkiv').forEach((arkiv) => {
		const knappar = Array.from(arkiv.querySelectorAll<HTMLButtonElement>('.filter-btn[data-type]'));
		const kort = Array.from(arkiv.querySelectorAll<HTMLElement>('.referens-arkiv__kort'));
		const tomt = arkiv.querySelector<HTMLElement>('.referens-arkiv__tomt');

		if (!knappar.length || !kort.length) {
			return;
		}

		let vald = 'all';

		const filtrera = (): void => {
			let traffar = 0;

			kort.forEach((item) => {
				const kategorier = item.dataset.category ? item.dataset.category.split(' ') : [];
				const synlig = vald === 'all' || kategorier.includes(vald);

				// hidden i stället för style.display: korten försvinner då även
				// för skärmläsare, inte bara visuellt.
				item.hidden = !synlig;

				if (synlig) {
					traffar += 1;
				}
			});

			if (tomt) {
				tomt.hidden = traffar > 0;
			}
		};

		knappar.forEach((knapp) => {
			knapp.addEventListener('click', () => {
				knappar.forEach((b) => {
					b.classList.remove('active');
					b.setAttribute('aria-pressed', 'false');
				});
				knapp.classList.add('active');
				knapp.setAttribute('aria-pressed', 'true');
				vald = knapp.dataset.type ?? 'all';
				filtrera();
			});
		});

		// Startläget speglas i aria-pressed så knapparnas tillstånd går att läsa.
		knappar.forEach((knapp) => {
			knapp.setAttribute('aria-pressed', knapp.classList.contains('active') ? 'true' : 'false');
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', referensFilterInit);
} else {
	referensFilterInit();
}
